import { ChangeDetectionStrategy, Component, HostBinding, Input, ViewEncapsulation } from "@angular/core";

@Component({
	selector: "obg-accordion-header-component",
	templateUrl: "./accordion-header.component.html",
	styleUrls: ["./accordion-header.component.scss"],
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccordionHeaderComponent {
	@HostBinding("class.obg-accordion-header-component") hostCssClass = true;

	@Input() expanded = false;
	@Input() key: string | undefined;
	@Input() titleText: string | undefined;
}
